import { render, staticRenderFns } from "./NewProduct.vue?vue&type=template&id=0360a55e&scoped=true"
import script from "./NewProduct.vue?vue&type=script&lang=js"
export * from "./NewProduct.vue?vue&type=script&lang=js"
import style0 from "./NewProduct.vue?vue&type=style&index=0&id=0360a55e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0360a55e",
  null
  
)

export default component.exports